import { create } from 'zustand';

interface KeyboardShortcutsState {
  isPanelOpen: boolean;

  // Actions
  togglePanel: () => void;
  setIsPanelOpen: (isOpen: boolean) => void;
}

const initialState = {
  isPanelOpen: false,
};

export const useKeyboardShortcutsStore = create<KeyboardShortcutsState>(
  (set) => ({
    ...initialState,

    togglePanel: () => {
      set((state) => ({ isPanelOpen: !state.isPanelOpen }));
    },

    setIsPanelOpen: (isOpen: boolean) => {
      set({ isPanelOpen: isOpen });
    },
  }),
);
